export default __webpack_public_path__ + "static/media/arpa3.3dbe6d94.mp3";